import { BaseDAO } from './baseDAO';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConstantMan } from '../constantMan';
import { ApiHelper } from '../apiHelper';
import { HttpHeaders } from '@angular/common/http';
import { Post } from 'anchor-shared/lib/model/entity/posts';

@Injectable()
export class PostsDAO extends BaseDAO<Post> {
  constructor(public readonly apiHelper: ApiHelper) {
    super(apiHelper, ConstantMan.API.RESOURCE.POSTS);
  }

  public getAll(): Observable<Post[]> {
    const url: string = this.apiHelper.getServiceName() + this.getResource();
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<Post[]>(url, method, null, null, headers);
  }

  public updateContentForPost(
    postId: number,
    postContent: string,
    trailingUrl: string,
    metaTitle: string,
    metaDescription: string,
    metaImage: string,
  ): Observable<Post> {
    const url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/' + postId;
    const method = 'PUT';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    const partial: Partial<Post> = {
      id: postId,
      content: postContent,
      trailingUrl: trailingUrl,
      metaTitle: metaTitle,
      metaDescription: metaDescription,
      metaImage: metaImage,
    };
    return this.apiHelper.apiCall<Post>(url, method, null, partial, headers);
  }

  public createPost(post: Partial<Post>): Observable<Post> {
    const url: string = this.apiHelper.getServiceName() + this.getResource();
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<Post>(url, method, null, post, headers);
  }

  public getDescriptionSuggestion(postId: number): Observable<any> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/gen/description/' +
      postId;
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<any>(url, method, null, null, headers);
  }

  public getPost(trailing: string): Observable<Post> {
    const url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/by-trailing';
    const method = 'PUT';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<Post>(
      url,
      method,
      null,
      {
        trailing: trailing,
      },
      headers,
    );
  }

  public getPostById(id: number): Observable<Post> {
    const url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/by/' + id;
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<Post>(url, method, null, null, headers);
  }
}
